export default __webpack_public_path__ + "static/media/one-inch.48098f9e.svg";